import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useUpdateCatalog } from 'modules/trainings/hooks/Trainings/useUpdateCatalog'

interface UpdateCatalogProps {
  action: 'display' | 'hide'
  itemIds: string[]
  onClose: () => void
}

const UpdateCatalog = ({ action, itemIds, onClose }: UpdateCatalogProps) => {
  const { updateCatalog, loading } = useUpdateCatalog()

  const description =
    action === 'display'
      ? i18n.t('trainings.update_catalog.description_add_bulk')
      : i18n.t('trainings.update_catalog.description_remove_bulk')

  const onSubmit = async () => {
    const response = await updateCatalog({
      ids: itemIds,
      catalog: action === 'display',
    })

    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.update_catalog.error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.update_catalog.success'),
      })
      onClose()
    }
  }

  return (
    <F0Dialog
      isOpen
      onClose={onClose}
      title={i18n.t('trainings.update_catalog.title')}
      primaryAction={{
        label: i18n.t('trainings.delete_training.accept'),
        onClick: onSubmit,
        loading: loading,
      }}
      secondaryAction={{
        label: i18n.t('trainings.delete_training.cancel'),
        onClick: onClose,
      }}
    >
      <Box gap="s8" flexDirection="column">
        <Text.Normal size="300">{description}</Text.Normal>
      </Box>
    </F0Dialog>
  )
}

export default UpdateCatalog
